import { useState, type ReactNode } from 'react'

import { Button, StatusMessage } from '@krp/ui-kit'
import { RmkDialog } from '@krp/sale-ui'

import type { RmkActions, RmkVm } from '../model/types'
import { OperationPanel } from './OperationPanel'

/** Закрытие остаётся внутри РМК; отказ не освобождает рабочее место и не закрывает смену. */
export function CloseShiftDialog({ vm, actions, children }: { vm: RmkVm; actions: RmkActions; children: ReactNode }) {
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const operation = vm.operation?.kind === 'close' ? vm.operation : null
  const feedback = vm.feedback
  const error = feedback !== null && ['shift.close', 'operation.reconcile'].includes(feedback.command) ? feedback.error : null
  const refusedBeforeAcceptance = feedback?.command === 'shift.close' && feedback.phase === 'rejected' && error !== null
  if (operation === null && !refusedBeforeAcceptance) return children
  const canDismiss = operation?.canDismiss ?? true
  const failed = operation === null || (canDismiss && operation.tone === 'danger')
  const dismiss = canDismiss ? () => { actions.dismissOperation(); actions.dismissFeedback() } : undefined
  return (
    <div className="rmk-close-stage" ref={setContainer}>
      <div inert>{children}</div>
      {container !== null && <RmkDialog title={failed ? 'Смена не закрыта' : 'Закрытие смены'}
        container={container} onClose={dismiss}>
        {operation !== null && <OperationPanel operation={operation} onCheck={actions.checkOperation} onReconcile={actions.reconcileOperation} onDismiss={() => dismiss?.()} />}
        {error !== null && <StatusMessage kind="error" title="Ответ службы" text={error.message} meta={[error.code, error.correlationId].filter(Boolean).join(' · ')} />}
        {failed && <Button variant="primary" disabled={vm.busy || !vm.shiftCommands.canClose} onClick={actions.closeShift}>
          Повторить закрытие смены
        </Button>}
      </RmkDialog>}
    </div>
  )
}
